<div class="template-reject-info-wrapper">
  <h2 mat-dialog-title class="template-reject-info-wrapper__title">
    Motivos comunes de rechazo
  </h2>
  <div
    mat-dialog-content
    class="template-reject-info-wrapper__content mat-typography">
    <p>
      Se suelen rechazar las plantillas enviadas por las razones que se indican a
      continuación. Por este motivo, asegúrate de no cometer estos errores.
    </p>
    <ul class="reason-reject-list">
      <li [innerHTML]="reasonRejectCustom1"></li>
      <li>
        Los parámetros variables contienen caracteres especiales, como #, $ o %.
      </li>
      <li [innerHTML]="reasonRejectCustom2"></li>
      <li>
        Las plantillas de mensajes presentan contenido que infringe la Política de
        comercio de WhatsApp: cuando ofreces productos o servicios para la venta,
        consideramos que todos los mensajes y contenidos multimedia relacionados con
        esos productos y servicios constituyen transacciones, incluidos los precios,
        descripciones, tarifas, impuestos y/o divulgaciones legales requeridos. Las
        transacciones deben cumplir con la
        <a href="https://www.whatsapp.com/legal/commerce-policy/" target="_blank"
          >Política de comercio de WhatsApp.</a
        >
      </li>
      <li>
        La plantilla de mensaje incluye contenido que infringe la
        <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank"
          >política de WhatsApp Business</a
        >: no solicites identificadores confidenciales a los usuarios. Por ejemplo,
        no les pidas que compartan números completos de tarjetas de pago
        individuales, números de cuentas bancarias, números de identificación
        personal u otros identificadores confidenciales. Tampoco debes solicitarles
        documentos que puedan contener identificadores confidenciales. No hay
        problema en solicitarles identificadores parciales (por ejemplo, los últimos
        4 dígitos del número de seguridad social).
      </li>
      <li>
        El contenido incluye material potencialmente abusivo o amenazante, como la
        amenaza de tomar acciones legales contra un cliente o avergonzarlo en
        público.
      </li>
      <li>
        La plantilla de mensaje es una copia de una plantilla preexistente. Si se
        envía una plantilla que tiene el mismo texto en el cuerpo y el pie de página
        que una plantilla preexistente, se rechazará la plantilla duplicada.
        Aparecerá una notificación de rechazo, con el motivo incluido, en la sección
        "Calidad de la cuenta" del administrador de WhatsApp, y también se enviará
        por correo electrónico. Puedes consultar la notificación de calidad de la
        cuenta para ver el nombre y el idioma de la plantilla preexistente que tiene
        el mismo contenido que la plantilla duplicada que se rechazó. También tienes
        la opción de editar la plantilla y volver a enviarla. Ten en cuenta que esta
        verificación no se aplica a las plantillas de OTP.
      </li>
      <li>
        Para más información ir a:
        <a
          href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines"
          target="_blank"
          >Message Template Guidelines - WhatsApp Bussiness Plataform - Documentation
          - Meta for Develop</a
        >
      </li>
    </ul>
  </div>
  <div mat-dialog-actions class="template-reject-info-wrapper__actions">
    <button mat-button (click)="matDialogRef.close()">CERRAR</button>
  </div>
</div>
